import { h, Component } from 'preact';

import Store from 'store/store';
import * as webp from 'utils/bolt/webp';
import { joinClasses, accessNested } from 'utils/utils';

import s from 'components/bolt/uarHeader/components/logo/logo.sss';

export default class Logo extends Component {
	getFallbackFormat() {
		return accessNested(Store.get(), 'appData.header.alternativeImageFormat', 'png');
	}

	render({ data, extraClass }) {
		const { logo } = data;
		const tt = logo.src;
		const fallbackFormat = this.getFallbackFormat();
		return (
			<a class={joinClasses(s.logo, extraClass)} href="https://mgm.com/">
				<webp.Picture
					src={tt}
					alt={logo.altText}
					fallbackFormat={fallbackFormat}
				/>
			</a>
		);
	}
}